import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signOut as firebaseSignOut
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAsSVTihQnY8xpZUgMMxgE3JJHskkAx9Ug",
  authDomain: "eyp-at.firebaseapp.com",
  projectId: "eyp-at",
  storageBucket: "eyp-at.appspot.com",
  messagingSenderId: "612866535424",
  appId: "1:612866535424:web:f4a9dd877ba67fc12368e5",
  measurementId: "G-3KJS6FDMRR"
};

const app       = initializeApp(firebaseConfig);
const auth      = getAuth(app);
const firestore = getFirestore(app);

// 2) Configure the “Sign in with Google” provider to hint at your domain
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ hd: 'eyp.at' });

// 3) Export only what you need downstream
export {
  app,
  auth,
  firestore,
  googleProvider,
  firebaseSignOut as signOut
};